import {
  clearAdminAccount,
  clearAdminAccountCatalogs,
  clearAdminAccountContractDetails,
  fetchAdminAccountDepartments,
  fetchAdminAccounts,
  selectAdminAccount,
  setAdminDepartmentCatalogTypes,
  bulkSetAdminDepartmentCatalogTypes,
  fetchSelectedAccountDepartments,
  addContractDepartmentAssociation,
  removeContractDepartmentAssociation
} from './actions';

export const DEFAULT_ACCOUNTS_STATE = {
  data: {},
  selectedAccountId: '',
  selectedAccountDepartments: [],
  isSubmittingContractDeptChange: false
};

const normalize = (state, accounts) => ({
  ...state,
  accounts
});

const accountsReducer = (state, action) => {
  const { accounts } = state;

  switch (action.type) {
    case fetchAdminAccounts.event.success: {
      const { objects } = action.payload;
      const newData = {};
      objects.forEach(
        account =>
          (newData[account.id] = {
            ...account,
            catalogs: [],
            contracts: [],
            departments: [],
            hasFetchedDepartments: false
          })
      );

      return normalize(state, { ...accounts, data: newData });
    }
    case selectAdminAccount.type:
      return normalize(state, { ...accounts, selectedAccountId: action.payload });
    case clearAdminAccount.type:
      return normalize(state, { ...accounts, selectedAccountId: '' });
    case clearAdminAccountCatalogs.type:
      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [accounts.selectedAccountId]: {
            ...accounts.data[accounts.selectedAccountId],
            catalogs: []
          }
        }
      });
    case clearAdminAccountContractDetails.type:
      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [accounts.selectedAccountId]: {
            ...accounts.data[accounts.selectedAccountId],
            contracts: []
          }
        }
      });
    case 'FETCH_ADMIN_ACCOUNT_CATALOGS_SUCCESS':
      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [accounts.selectedAccountId]: {
            ...accounts.data[accounts.selectedAccountId],
            catalogs: action.payload.catalogs
          }
        }
      });
    case 'FETCH_ADMIN_ACCOUNT_CONTRACTS_SUCCESS':
      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [accounts.selectedAccountId]: {
            ...accounts.data[accounts.selectedAccountId],
            contracts: action.payload.contracts
          }
        }
      });
    case fetchAdminAccountDepartments.event.success: {
      const { adminAccountId, departments } = action.payload;
      const salesOrg = state.accounts.data[adminAccountId]?.salesOrg;
      const toIncludeSalesOrg = departments.map(dept => ({ ...dept, salesOrg }));

      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [adminAccountId]: {
            ...accounts.data[adminAccountId],
            hasFetchedDepartments: true,
            departments: toIncludeSalesOrg
          }
        }
      });
    }
    case fetchAdminAccountDepartments.event.error: {
      const { adminAccountId } = action.payload;

      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [adminAccountId]: { ...accounts.data[adminAccountId], hasFetchedDepartments: true }
        }
      });
    }
    case setAdminDepartmentCatalogTypes.type: {
      const { accountId, departmentId, catalogTypeIds } = action.payload;

      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [accountId]: {
            ...accounts.data[accountId],
            departments: accounts.data[accountId].departments.map(dept =>
              dept.id === departmentId ? { ...dept, catalogTypes: catalogTypeIds } : dept
            )
          }
        }
      });
    }
    case bulkSetAdminDepartmentCatalogTypes.type: {
      const { accountId, departmentIdToCatalogTypes } = action.payload;

      return normalize(state, {
        ...accounts,
        data: {
          ...accounts.data,
          [accountId]: {
            ...accounts.data[accountId],
            departments: accounts.data[accountId].departments.map(dept => {
              const deptCatalogTypes = departmentIdToCatalogTypes[dept.id];
              if (!deptCatalogTypes) return dept;
              return { ...dept, catalogTypes: deptCatalogTypes.map(ct => ct.id) };
            })
          }
        }
      });
    }
    case fetchSelectedAccountDepartments.event.success:
      return normalize(state, { ...accounts, selectedAccountDepartments: action.payload.objects });
    case addContractDepartmentAssociation.event.start:
    case removeContractDepartmentAssociation.event.start:
      return normalize(state, { ...accounts, isSubmittingContractDeptChange: true });
    case addContractDepartmentAssociation.event.success:
    case removeContractDepartmentAssociation.event.success:
    case addContractDepartmentAssociation.event.error:
    case removeContractDepartmentAssociation.event.error:
      return normalize(state, { ...accounts, isSubmittingContractDeptChange: false });
    default:
      return state;
  }
};

export default accountsReducer;
